class MakeBreadcrumb {
    constructor() {
        this.CACSection               = document.getElementById('choose-a-cable-section');
        this.form                     = this.CACSection.querySelector('#buildings-form');
        this.slides                   = this.CACSection.querySelectorAll('.slide');
        this.inactiveSlides           = this.CACSection.querySelectorAll('.inactive');
        this.slidesInForm             = this.form.querySelectorAll('.slide');
        this.firstSlide               = 0;
        this.slidesNumberInactive     = [];
        this.inactiveSlidesNumber     = null;
        this.breadcrumbContent        = ['', 'Type de bâtiments', 'Catégorie', 'Type de câbles', 'Conditions d\'influences', '', '', '', 'Résultats'];

        this.buildBreadcrumb();
    }

    buildBreadcrumb() {

        // get the number of the slides that are inactive
        // and storage all the numbers into an array
        for (let i = 0; i < this.slidesInForm.length; i++) {
            if (this.slides[i].classList.contains('inactive')) {
                this.slidesNumberInactive.push(i);
            }
        }


        for (let i = 0; i < this.slides.length; i++) {

            // get the current slide
            if (this.slides[i].classList.contains('active')) {

                let breadcrumb = this.slides[i].querySelector('.breadcrumb');
                let liElt      = breadcrumb.querySelectorAll('li');

                // every call of the class (MakeBreadcrumb) will delete all the li elements in the breacrumb
                for (let j = 1; j < liElt.length; j++) {
                    breadcrumb.removeChild(liElt[j]);
                }

                // create a number of li elements depending of how many slides are inactive
                for (let j = 0; j < this.inactiveSlides.length; j++) {

                    let newListElt = document.createElement('li');

                    // the textcontent will be created according to breadcrumbContent which is an array containing all the
                    // slide names. So we have to loop in the slidesNumberInactive array and then get the content bound to
                    // slidesNumberInactive indexes
                    newListElt.textContent = (j === this.firstSlide) ? `${this.breadcrumbContent[this.slidesNumberInactive[j]]}` : ` > ${this.breadcrumbContent[this.slidesNumberInactive[j]]}`;
                    newListElt.classList.add('active');
                    breadcrumb.appendChild(newListElt);
                }

                // and then create the last li element which will be the name of the current slide
                let newLastListElt         = document.createElement('li');
                newLastListElt.textContent = ` > ${this.breadcrumbContent[i]}`;
                newLastListElt.classList.add('active');
                breadcrumb.appendChild(newLastListElt);
            }
        }
    }
}